import React, { useEffect, useState } from "react";
import {
    formatPhoneNumber,
    getAutoComplete,
    validateInput,
} from "../../../../../legacy/utils/helpers";
import Input from "./Input";
import { QuestionnaireQuestionChoiceUniqueKeys } from "src/containers/QuestionnaireParent/QuestionnaireEnum";

type Props = {
    className?: string,
    placeholder?: string,
    onChange: Function,
    value?: string,
    required?: boolean,
    props?: Object,
    feedbackMessage?: string,
    infoMessage?: any,
    uniqueKey?: String,
    metadata?: Object,
    pageUniqueKey?: String,
};

export default function InputContainer({
    className = "",
    placeholder,
    onChange,
    value,
    isRequired,
    feedbackMessage,
    infoMessage,
    metadata,
    uniqueKey,
    pageUniqueKey = "",
}: Props): React$Element<any> {
    const isPhoneNumber =
        uniqueKey && uniqueKey.toLocaleLowerCase().includes("phonenumber");
    const isZipCode =
        uniqueKey && uniqueKey.toLocaleLowerCase().includes("zipcode");
    const typeOfInput =
        metadata?.validation_type && !isPhoneNumber && !isZipCode
            ? metadata?.validation_type
            : "text";
    const isFeeInput =   uniqueKey && uniqueKey.toLocaleLowerCase().includes("fee");
    const MAX_FEE_LIMIT = 9999;
    const [isRequiredInput, setisRequiredInput] = useState(false);
    const [isInValidInput, setisInValidInput] = useState(false);
    const [inputValue, setInputValue] = useState(value);
    const phoneRegex = "\\(\\d\\d\\d\\)\\s\\d\\d\\d-\\d\\d\\d\\d";
    const [inputFeedbackMessage, setinputFeedbackMessage] =
        useState(feedbackMessage);

    useEffect(() => {
        if (value !== inputValue) {
            onInputChange({
                target: {
                    value,
                },
            });
        } else {
            setInputValue(value);
        }
    }, [value]);

    const onInputChange = (event) => {
        let newValue = event?.target?.value; // always trim


        if (newValue === " " || newValue === "  ") {
            newValue = newValue.trim();
        } else if (newValue.includes("  ")) {
            newValue = newValue.replace("  ", " ");
        }

        /* the new value contains white space */
        if (newValue?.length === 1 && newValue?.trim() !== newValue) {
            return;
        }

        const userInput: any = newValue;

        if (isPhoneNumber) {
            const formattedPhoneNumber = formatPhoneNumber(newValue);

            newValue = formattedPhoneNumber;

            if (
                formattedPhoneNumber?.length <
                    metadata?.validation_char_length + 4 ||
                formattedPhoneNumber === "" ||
                formattedPhoneNumber?.length >
                    metadata?.validation_char_length + 4
            ) {
                setisInValidInput(true);
                setisRequiredInput(true);
                setinputFeedbackMessage(
                    "Please enter a 10 digit phone number."
                );
                onChange(newValue, false);
            } else {
                setisRequiredInput(false);
                setisInValidInput(false);
                onChange(newValue);
                setinputFeedbackMessage("");
            }

            setInputValue(newValue);

            return;
        } else if (isZipCode) {
            newValue = newValue
                .replace(/[^\d]/g, "")
                ?.slice(0, metadata?.validation_char_length);

            if (
                newValue.length < metadata?.validation_char_length ||
                newValue === ""
            ) {
                setisInValidInput(true);
                setisRequiredInput(true);
                setinputFeedbackMessage("Please enter valid zip code.");
                onChange(newValue, false);
            } else {
                setisRequiredInput(false);
                setisInValidInput(false);
                onChange(newValue);
                setinputFeedbackMessage("");
            }

            setInputValue(newValue);

            return;
        } else if (isFeeInput) {
            newValue = newValue
                .replace(/^0+(?=\d)/, '')
                .replace(/[^0-9.]/g, '');

            if (newValue.includes(".")) {
                const [integer, decimal] = newValue.split(".");

                newValue = `${integer}.${decimal.slice(0, 2)}`;
            }
            else {
                // If there's no decimal yet, just restrict the integers to 4 as discussed
                newValue = newValue.slice(0, 4);
            }

            if (
                newValue.length < metadata?.validation_char_length ||
                newValue === ""
            ) {
                setisInValidInput(true);
                setisRequiredInput(true);
                setinputFeedbackMessage("Please enter a valid fee");
                onChange(newValue, false);
            } else {
                setisRequiredInput(false);
                setisInValidInput(false);
                onChange(newValue);
                setinputFeedbackMessage("");
            }

            setInputValue(newValue);

            return;
        } else {
            // handling space issue while user input
            if (userInput === " ") {
                newValue = "";
            } else {
                newValue = userInput?.replace("  ", " ");
            }

            setInputValue(newValue);
        }

        if (newValue === "" && isRequired === false) {
            setisRequiredInput(false);
            setisInValidInput(false);
            setinputFeedbackMessage("");
            onChange(newValue);
        } else if (
            (newValue === undefined ||
                newValue === "" ||
                (typeOfInput === "number" &&
                    (newValue.includes("-") ||
                        newValue.includes("+") ||
                        newValue.includes("e")) &&
                    isRequired)) &&
            !isPhoneNumber &&
            !isZipCode
        ) {
            setisRequiredInput(true);
            setisInValidInput(true);
            setinputFeedbackMessage("This field is required");
            onChange(newValue, false);
        } else if (
            newValue?.length > metadata?.validation_char_length &&
            !isPhoneNumber &&
            !isZipCode
        ) {
            setisInValidInput(true);
            setisRequiredInput(true);
            setinputFeedbackMessage("Maximum characters limit exceeded");
            onChange(newValue, false);
        } else {
            const isValid = metadata?.validation
                ? validateInput(metadata.validation, newValue)
                : isPhoneNumber
                ? validateInput(phoneRegex, newValue)
                : true;

            if (isValid) {
                setisRequiredInput(false);
                setisInValidInput(false);
                setinputFeedbackMessage("");
            } else {
                setisInValidInput(true);
                setisRequiredInput(true);
                setinputFeedbackMessage(
                    metadata?.error_message
                        ? metadata?.error_message
                        : isPhoneNumber
                        ? "Not a valid phone number"
                        : "Invalid format"
                );
            }

            onChange(newValue, isValid);
        }
    };

    const handleFocusOut = (event) => {
        onInputChange(event);
    };

    return (
        <Input
            variant=""
            className={className}
            infoMessage={infoMessage}
            placeholder={placeholder}
            isRequired={isRequiredInput}
            onChange={onInputChange}
            onFocusOut={handleFocusOut}
            isInvalid={isInValidInput}
            value={inputValue} // need to discsuu the local input or the redux state of it
            type={typeOfInput}
            feedbackMessage={inputFeedbackMessage}
            autoComplete={getAutoComplete(pageUniqueKey)}
            showDollarSign={
                uniqueKey ===
                QuestionnaireQuestionChoiceUniqueKeys.feeTherapistChoiceV1
            }
            onKeyPress={(e) => {
                if (uniqueKey === QuestionnaireQuestionChoiceUniqueKeys.feeTherapistChoiceV1) {
                    if (!/^[\d.]$/.test(e.key) || (e.key === "." && Number(inputValue) >= MAX_FEE_LIMIT)) {
                        e.preventDefault();
                    }
                } else if (typeOfInput === "number") {
                    if (!(/^\d+$/.test(e.key))) e.preventDefault();
                }
            }}
        />
    );
}
